import { useSession } from "@hono/auth-js/react";
import { ChevronRight, History } from "lucide-react";
import { Link } from "react-router";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarHeader,
} from "~/components/ui/sidebar";
import { useGetFlashcardsHistory } from "~/lib/hooks/api.hooks";

import { Button } from "./ui/button";

export function AppSidebar() {
  const auth = useSession();
  const flashCardsHistory = useGetFlashcardsHistory();

  return (
    <Sidebar className="bg-background">
      <SidebarHeader>
        <Link to={"/app"}>
          <span className="font-semibold">Hi {auth.data?.user?.name}</span>
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel className="flex gap-4 items-center">
            <span>Learning History</span> <History className="mt-px" />
          </SidebarGroupLabel>
          <SidebarContent>
            {flashCardsHistory.data?.map((historyItem) => (
              <Link
                to={`/app/flashcards/${historyItem.id}`}
                key={historyItem.id}
              >
                <Button
                  variant="outline"
                  className="w-full relative flex justify-between items-center"
                >
                  <span className="truncate">{historyItem.title}</span>
                  <span className="text-primary opacity-0 hover:opacity-100 transition-all">
                    <span className="absolute inset-0" />
                    <ChevronRight />
                  </span>
                </Button>
              </Link>
            ))}

            {flashCardsHistory.isLoading && (
              <div className="text-center text-muted-foreground my-auto min-h-96 flex items-center justify-center">
                Loading...
              </div>
            )}
          </SidebarContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>
        {/* new Phrase */}
        <Link to="/app" className="text-center">
          <Button className="w-full" size="sm">
            New Phrase/Word
          </Button>
        </Link>
        {/* feedback link https://www.admonymous.co/vajin*/}
        <a
          href="https://www.admonymous.co/vajin"
          target="_blank"
          rel="noreferrer"
          className="text-center"
        >
          <Button variant="link">Submit a Feedback</Button>
        </a>
      </SidebarFooter>
    </Sidebar>
  );
}
